export default __webpack_public_path__ + "static/media/slider.df41d162.svg";